import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  PageHeader,
  Row,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import { DELETE, GET, UPDATE } from "../constants/request-type";
import {
  delete_push,
  get_all_push,
  push,
  update_push
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";

import logger from "../../utils/logger.js";
import Push_new from "../forms/push_new";
import Send_push from "../forms/send_push";
import { decryptSingleData } from "../functions/cryptojs";
const token = sessionStorage.getItem("auth_token");

class NotificationAds extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    overall: true,
    allowed: false,
    blocked: false
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: push + "/" + get_all_push,
      data: null,
      token: token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        load: false,
        data: decryptSingleData(response.data.push)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: push + "/" + delete_push + "/" + id,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: push + "/" + update_push + "/" + id,
      data: data,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id"),
        fixed: "left"
      },
      {
        title: "message",
        dataIndex: "message",

        ...this.getColumnSearchProps("message"),

        render: (text) => {
          return (
            <Tag color={"blue"} key={text}>
              {text}
            </Tag>
          );
        }
      },
      {
        title: "icon",
        dataIndex: "icon",

        ...this.getColumnSearchProps("icon"),

        render: (text) => {
          return (
            <a href={text} target="_blank" rel="noreferrer">
              <img
                src={text}
                alt="img"
                style={{
                  width: 50,
                  height: 50
                }}
              />
            </a>
          );
        }
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Send_push row={record} />
        </Menu.Item>
        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item>
      </Menu>
    );

    const { load, data } = this.state;

    return (
      <>
        <PageHeader
          title="Notifications"
          tags={<Tag color="blue">Liste des push</Tag>}
          subTitle=""
          extra={[<Push_new />]}
        >
          <Row>
            <Statistic title="Total" value={data.length} />
          </Row>
          <Row>
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table columns={columns} dataSource={data} />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchStoreToProps
)(NotificationAds);
